import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ShopCategoriesType } from '../../../../types/shopCategories';
import { InputLink } from '../../../atoms';
import { SHOP_CATEGORIES } from '../../../../constants/define/translation';

interface ColumnProps {
  record: ShopCategoriesType;
  handleChangeInputLink: Function;
  handleAddLink: Function;
  loading?: boolean;
  onValidateInput?: Function;
  onFocusNewRow: Function;
}

export default React.memo((props: ColumnProps) => {
  const { t } = useTranslation(SHOP_CATEGORIES);
  const { record, handleChangeInputLink, handleAddLink, loading, onFocusNewRow } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ ctaLink: record?.ctaLink });
  }, [record]);

  const renderView = () => {
    return (
      <StyledInputLinkContainer onClick={() => window.open(record?.ctaLink, '_blank')}>
        <div className="render-video">{record?.ctaLink}</div>
      </StyledInputLinkContainer>
    );
  };

  const submitInput = async () => {
    try {
      document
        .getElementById(`form_input_title_category_${record.index}`)
        ?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      await form.validateFields();
      handleAddLink(record?.index);
    } catch (error) {
      //
    }
  };

  const onChangeInput = (e: any) => {
    form.setFieldsValue({ ctaLink: e.target.value });
    handleChangeInputLink(record.index, e.target.value);
  };

  const renderCreateInput = () => {
    return (
      <StyledFormInputLinkContainer>
        <Form form={form} autoComplete="off">
          <Form.Item name="ctaLink" rules={[{ required: true, message: t('validate.ctaLinkBlank') }]}>
            <InputLink
              loading={loading}
              record={record}
              onChangeInput={onChangeInput}
              submitInput={submitInput}
              onFocusNewRow={onFocusNewRow}
            />
          </Form.Item>
        </Form>
      </StyledFormInputLinkContainer>
    );
  };

  return record?.id && !record?.isInEditMode ? renderView() : renderCreateInput();
});

const StyledFormInputLinkContainer = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;

const StyledInputLinkContainer = styled.div`
  display: flex;
  align-items: center;
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left;

  .ant-typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .box {
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .render-video {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px;
    word-break: break-all;
  }
`;
